import { createReducer, on } from '@ngrx/store';
import { ConversionRateInterface } from '../types/currency-conversion-rate';
import { defaultConversionRateFilter } from '../types/currency-conversion-rate-filter';
import {
  fetchConversionRate,
  loadedConversionRate,
  failedConversionRate,
  updateConversionRateFilter,
  deleteVelocityLimit,
  resetConversionRate,
} from './conversion-rate.actions';
import {
  initialConversionRateState,
  ConversionRateState,
  initialDataSource,
} from './conversion-rate.state';

export const conversionRateReducer = createReducer(
  initialConversionRateState,
  on(fetchConversionRate, (state): ConversionRateState => ({ ...state })),
  on(loadedConversionRate, (state, action): ConversionRateState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: action.dataSource,
    };
  }),
  on(failedConversionRate, (state): ConversionRateState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: { ...initialDataSource },
    };
  }),
  on(updateConversionRateFilter, (state, { filter }): ConversionRateState => {
    return {
      ...state,
      filter: {
        ...state.filter,
        ...(filter ?? defaultConversionRateFilter),
      },
      dataSource: { ...state.dataSource },
    };
  }),
  on(deleteVelocityLimit, (state, action): ConversionRateState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: {
        ...state.dataSource,
        rawData: state.dataSource.rawData?.filter(
          (velocityLimit: ConversionRateInterface) =>
            velocityLimit.id !== action.id
        ),
      },
    };
  }),
  on(resetConversionRate, (state): ConversionRateState => {
    return {
      ...state,
      filter: { ...defaultConversionRateFilter },
      dataSource: { ...state.dataSource },
    };
  })
);
